import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslationModuleEnum } from 'src/app/utils/translation-modules.enum';
@Component({
  selector: 'app-stats-widget',
  templateUrl: './stats-widget.component.html',
  styleUrls: ['./stats-widget.component.scss'],
})
export class StatsWidgetComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;

  @Input() id: string;
  @Input() WidgetColorType: 'normal' | 'colorFul' = 'normal';
  @Input() count: number;
  @Input() title: string;
  @Input() titleTranslationKey: string;
  @Input() titleTranslationModuleEnum: any;
  @Input() icon: string;
  @Input() type: 'default' | 'primary' | 'warning' | 'success' | 'danger';
  @Input() titleColor?: string = '#2a2a2a';
  @Input() iconColor: string = 'black';
  @Input() iconBGColor: string = 'white';
  @Input() iconContainerColor: string = 'white';
  @Input() widgetColor: string = 'black';
  @Input() hasBorder: boolean = false;
  @Input() borderColor: string = 'white';
  @Input() textColor: string = 'white';
  @Input() hasPercentage: boolean = false;
  @Output() onClick = new EventEmitter();
  @Input() innovation: boolean = false;
  @Input() hasCurrency: boolean = false;
  @Input() currency: string = 'AED';
  @Input() imageIcon: boolean = false;
  constructor() { }

  ngOnInit(): void { }

  emitStatId() {
    this.onClick.emit(this.id);
  }
}
